import { Controller } from "@hotwired/stimulus"

// Espelho do digit-only-input: aqui número nenhum passa. Nome de pessoa com
// dígito ("0liveira" no lugar de "Oliveira") é sempre erro de digitação, e a
// Clicksign recusa o signatário — o contrato só quebra lá na frente, depois
// do pagamento. Barramos na tecla; PersonNameValidations garante no servidor.
export default class extends Controller {
  connect() {
    this.handler = this.strip.bind(this)
    this.element.addEventListener("input", this.handler)
  }

  disconnect() {
    this.element.removeEventListener("input", this.handler)
  }

  strip(event) {
    const input = event.target
    const cleaned = input.value.replace(/\d/g, "")
    if (cleaned === input.value) return

    // Preserva a posição do cursor: sem isso, digitar no meio do nome joga o
    // cursor pro fim a cada dígito recusado.
    const caret = input.selectionStart
    const removedBefore = input.value.slice(0, caret).length -
      input.value.slice(0, caret).replace(/\d/g, "").length

    input.value = cleaned
    input.setSelectionRange(caret - removedBefore, caret - removedBefore)
  }
}
